<template>
  <div class="greyx lighten-3" style="min-height: 675px">
    <v-toolbar color="transparent" flat>
      <v-toolbar-title
        >Viaggio <span class="text--disabled ml-3">compilare tutte le parti richieste</span></v-toolbar-title
      >
      <v-spacer />
      <v-select
        v-model="form.day"
        outlined
        :items="dateItems"
        item-value="id"
        item-text="desc"
        :dense="dense"
        hide-details
        prepend-inner-icon="mdi-calendar"
        style="max-width: 360px"
      >
      </v-select>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')" class="mr-3"> Annulla </v-btn>
      <v-btn depressed @click="submit" color="primary" class="px-5" :disabled="!form.type">
        <v-icon left>mdi-content-save-outline</v-icon>
        Salva
      </v-btn>
    </v-toolbar>

    <v-form v-model="valid" ref="journeyForm" :lazy-validation="lazyValidation">
      <div class="inline-forms px-3">
        <v-row>
          <v-col class="places pr-0" cols="5">
            <v-card flat outlined>
              <v-card-title class="text-body-2 mt-0 pt-3 pb-4">Informazioni sulle località</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="8">
                    <search-place-field
                      label="Località di partenza"
                      v-model="form.origin"
                      outlined
                      placeholder="Digita il nome della località"
                      auto-select-first
                      required
                      :rules="placeRules"
                      :disabled="!canChangeOriginPlace"
                      :dense="dense"
                      autofocus
                      prepend-icon="mdi-alpha-a-circle"
                    />
                  </v-col>
                  <v-col md="4">
                    <v-select
                      label="Tipologia*"
                      v-model="form.origin_type"
                      :items="placeTypes"
                      item-value="id"
                      item-text="desc"
                      outlined
                      class=""
                      required
                      :rules="placeTypeRules"
                      :disabled="!canChangeOriginPlace || !form.origin"
                      :dense="dense"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <search-place-field
                      label="Località di arrivo"
                      v-model="form.destination"
                      placeholder="Digita il nome della località"
                      auto-select-first
                      required
                      :rules="placeRules"
                      :disabled="!canChangeDestinationPlace || !(form.origin && form.origin_type)"
                      :dense="dense"
                      outlined
                      class="input-row"
                      prepend-icon="mdi-alpha-b-circle-outline"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      label="Tipologia*"
                      v-model="form.destination_type"
                      :items="placeTypes"
                      item-value="id"
                      item-text="desc"
                      outlined
                      class="input-row"
                      required
                      :rules="placeTypeRules"
                      :disabled="!canChangeDestinationPlace || !form.destination"
                      :dense="dense"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="coupled-vehicle" cols="3">
            <v-card flat outlined>
              <v-card-title class="text-body-2 mt-0 pt-3 pb-3"> Rimorchio/Semirimorchio agganciato </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-select
                      v-model="form.coupled_vehicle"
                      :items="coupledVehicleTypes"
                      item-value="id"
                      item-text="desc"
                      :dense="dense"
                      outlined
                      clearable
                      placeholder="Seleziona un tipo"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-text-field
                      label="Assi"
                      type="number"
                      v-model.number="form.coupled_vehicle_axles"
                      min="0"
                      outlined
                      class="input-row"
                      required
                      :disabled="!form.coupled_vehicle"
                      :rules="vehicleLoadCapacityRules"
                      :dense="dense"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      label="Portata utile"
                      type="number"
                      v-model.number="form.coupled_vehicle_load_capacity"
                      min="0"
                      outlined
                      class="input-row"
                      suffix="q"
                      required
                      :disabled="!form.coupled_vehicle"
                      :rules="vehicleLoadCapacityRules"
                      :dense="dense"
                      hint="in quintali (q)"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="embarking pl-0" cols="4">
            <v-card flat outlined>
              <v-card-title class="text-body-2 mt-0 pt-3 pb-3">
                <v-switch
                  v-model="form.embarking"
                  label="Automezzo imbarcato su treno o nave"
                  class="py-0 my-0"
                  hide-details
                  inset
                  :disabled="this.isRoundOrShuttle"
                />
              </v-card-title>
              <v-card-text v-show="!isRoundOrShuttle">
                <v-row class="embarking-fieldset" v-if="form.embarking || true">
                  <v-col cols="12">
                    <v-select
                      label="Mezzo di trasporto"
                      v-model="form.embarking_type"
                      :items="embarkingTypes"
                      item-value="id"
                      item-text="desc"
                      class=""
                      outlined
                      :dense="dense"
                      :rules="embarkingTypeRules"
                      :disabled="!form.embarking"
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                    <search-place-field
                      label="Località di imbarco*"
                      v-model="form.embarking_from"
                      auto-select-first
                      :disabled="!form.embarking"
                      :required="!form.embarking_type"
                      :dense="dense"
                      class="input-row"
                      :rules="embarkingFromRules"
                      outlined
                    />
                  </v-col>
                  <v-col cols="6">
                    <search-place-field
                      label="Località di sbarco*"
                      v-model="form.embarking_to"
                      auto-select-first
                      :disabled="!form.embarking"
                      :required="!form.embarking_type"
                      :dense="dense"
                      :rules="embarkingToRules"
                      class="input-row"
                      outlined
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-show="isRoundOrShuttle">
                L'imbarco su nave o treno non è possibile per questa tipologia di viaggio.
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="foreign mt-n1" v-show="isForeign">
          <v-col cols="12">
            <v-card flat outlined>
              <!-- <v-card-title class="text-body-1 mt-0 pt-3 pb-3">Informazioni sulle località</v-card-title> -->
              <v-card-text class="mb-0 pb-0">
                <v-row class="foreing-jounery-fieldset">
                  <!-- Punto di frontiera -->
                  <v-col cols="5">
                    <v-autocomplete
                      label="Punto di frontiera attraversato in ingresso e/o in uscita dall'Italia*"
                      v-model="form.crossed_border"
                      :items="borders"
                      item-value="code"
                      item-text="name"
                      outlined
                      return-object
                      required
                      :rules="crossedBorderRules"
                      :dense="dense"
                      persistent-placeholder
                    />
                  </v-col>

                  <!-- Stati esteri attraversati -->
                  <v-col cols="7">
                    <v-autocomplete
                      label="Stati esteri attraversati senza effettuare fermate (opzionale, max 5)"
                      v-model="form.crossed_countries"
                      :items="countries"
                      item-value="code"
                      item-text="name"
                      persistent-hint
                      outlined
                      multiple
                      return-object
                      deletable-chips
                      :rules="crossedCountriesRules"
                      :dense="dense"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="details pt-0 mt-0" v-if="form.type">
          <v-col :cols="isStandard ? 3 : 4" class="details__journey pr-1">
            <v-card class="d-flex flex-column" outlined flat>
              <v-card-text>
                <v-select
                  label="Tipo viaggio"
                  v-model="form.type"
                  :items="currentJourneyTypeChoices.filter((o) => !o.disabled)"
                  outlined
                  dense
                  item-value="id"
                  item-text="title"
                  :disabled="!canChangeJourneyType"
                  hide-details
                  class="mb-2"
                >
                  <template #item="{ item, on }">
                    <v-list-item v-on="on" :disabled="item.disabled">
                      <v-list-item-avatar>
                        <v-icon :class="item.iconColor" dark> {{ item.icon }} </v-icon>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <div class="font-weight-regular" v-html="item.desc" />
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <div class="font-weight-regular text-caption text--disabled mt-n1" v-html="item.example" />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </v-card-text>
              <template>
                <v-card-text class="non-standard-distances py-0" v-if="isRound || isShuttle">
                  <div class="d-flex">
                    <div class="flex-grow-1 mt-2">
                      Totale viaggi
                      <small class="d-block text--secondary mt-n1" v-if="isShuttle"
                        >Ogni andata e ritorno si considera come singolo viaggio</small
                      >
                    </div>
                    <v-text-field
                      type="number"
                      v-model.number="form.journeys_count"
                      :min="isShuttle ? 3 : 1"
                      outlined
                      style="max-width: 100px"
                      required
                      :rules="journeysCountRules"
                      :dense="dense"
                    />
                  </div>
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      Km percorsi con carico
                      <small class="d-block text--secondary mt-n1">{{
                        isShuttle && form.goods[0] && form.goods[0].type && form.goods[1] && form.goods[1].type
                          ? `andata + ritorno`
                          : `per singolo viaggio`
                      }}</small>
                    </div>
                    <v-text-field
                      type="number"
                      v-model.number="form.distance_loaded"
                      min="0"
                      outlined
                      required
                      :rules="distanceLoadedRules"
                      :dense="dense"
                      style="max-width: 100px"
                    />
                  </div>

                  <div class="d-flex">
                    <div class="flex-grow-1">
                      Km percorsi senza carico
                      <small class="d-block text--secondary mt-n1">per singolo viaggio</small>
                    </div>
                    <v-text-field
                      type="number"
                      v-model.number="form.distance_empty"
                      min="0"
                      outlined
                      required
                      :rules="distanceEmptyRules"
                      :dense="dense"
                      style="max-width: 100px"
                      :disabled="!!(this.form.goods[0] && this.form.goods[1])"
                    />
                  </div>
                </v-card-text>
                <v-card-text class="standard-distance py-0" v-else>
                  <div class="d-flex">
                    <div class="flex-grow-1 mt-2">Km percorsi</div>
                    <v-text-field
                      type="number"
                      v-model.number="form.distance_total"
                      min="1"
                      outlined
                      class=""
                      required
                      :rules="distanceRules"
                      :dense="dense"
                      style="max-width: 100px"
                      placeholder=" "
                      :disabled="!(form.destination && form.destination_type)"
                    />
                  </div>
                </v-card-text>
              </template>
            </v-card>
          </v-col>
          <!-- <v-col cols="12" class="details__stops" > </v-col> -->
          <v-fade-transition>
            <v-col
              class="details__goods d-flex flex-column justify-space-between pl-2"
              v-if="isStandard || isRoundOrShuttle"
            >
              <div class="goods" v-if="isStandardNotEmpty || isRoundOrShuttle">
                <v-card flat outlined>
                  <template v-if="isStandard">
                    <div class="px-4 py-2">
                      Merce trasportata da <span class="font-weight-bold">{{ form.origin.full_name }}</span> a
                      <span class="font-weight-bold">{{ form.destination.full_name }}</span>
                    </div>
                    <v-divider></v-divider>
                    <journey-form-standard-goods-table>
                      <template v-for="(item, index) in form.goods">
                        <journey-form-standard-goods-table-row
                          :value="item"
                          :key="index"
                          v-if="!(item.is_inherited && item.weights.onboard === 0)"
                          :disabled="!canChangeGoods"
                          @input="(value) => $set(form.goods, index, value)"
                          @click:edit="editGoods(index)"
                          @click:delete="deleteGoods(index)"
                        />
                      </template>
                    </journey-form-standard-goods-table>
                    <!-- BUTTON AGGIUNGI MERCE -->
                    <v-divider />
                    <v-sheet class="px-4 py-2" v-if="canAddAnotherGoods">
                      <v-btn
                        class="rounded-lg py-2 my-2"
                        depressed
                        :disabled="!canAddAnotherGoods"
                        @click="addGoods"
                        right
                      >
                        <v-icon left color="success">mdi-plus-circle</v-icon>
                        Aggiungi merce
                      </v-btn>
                    </v-sheet>

                    <v-expand-transition> </v-expand-transition>
                  </template>
                  <template v-else>
                    <journey-form-goods-table
                      v-model="form.goods"
                      :labels="
                        isRound ? [`MERCE RACCOLTA`, `MERCE DISTRIBUITA`] : [`VIAGGIO DI ANDATA`, `VIAGGIO DI RITORNO`]
                      "
                      :messages="
                        isRound
                          ? [
                              `Compilare solo se nel viaggio si è raccolta merce`,
                              `Compilare solo se nel viaggio si è distribuita merce`,
                            ]
                          : [
                              `Compilare solo se nel viaggio di andata si è trasportata merce`,
                              `Compilare solo se nel viaggio di ritorno si è trasportata merce`,
                            ]
                      "
                      @click:add="setGoods"
                      @click:edit="editGoods"
                      @click:delete="unsetGoods"
                    />
                  </template>
                </v-card>
                <v-text-field
                  v-if="isStandard && hasExceptionalTrasportGoods"
                  v-model="form.exceptional_transport_desc"
                  outlined
                  label="Descrizione merce del trasporto eccezionale"
                  class="pt-3"
                  placeholder="Inserire una breve descrizione della merce trasportata"
                  :rules="exceptionalTransportDescRules"
                  :dense="dense"
                ></v-text-field>
              </div>
              <v-card class="d-flex flex-row" outlined flat v-if="isRound">
                <v-row class="mb-0 pb-0 px-4">
                  <v-col class="d-flex mb-0 pb-0">
                    <div class="flex-grow-1 mt-2">Fermate totali</div>
                    <v-text-field
                      type="number"
                      v-model.number="form.stops_count"
                      min="3"
                      outlined
                      style="max-width: 100px"
                      required
                      :rules="stopsCountRules"
                      :dense="dense"
                    />
                  </v-col>
                  <v-col class="d-flex mb-0 pb-0">
                    <div class="flex-grow-1">
                      Fermate
                      <small class="d-block text--secondary mt-n1">nella provincia di partenza</small>
                    </div>
                    <v-text-field
                      type="number"
                      v-model.number="form.stops_province_count"
                      :min="0"
                      :max="form.stops_count"
                      outlined
                      style="max-width: 100px"
                      required
                      :rules="stopsProvinceCountRules"
                      :dense="dense"
                    />
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-fade-transition>
        </v-row>

        <v-card flat outlined v-if="!form.type" elevation="3">
          <v-card-text class="text-body-2 text--primary pb-2"
            >In base alle indicazioni da te inserite, la tipologia di viaggio potrebbe corrispondere ad una di quelle di
            seguito evidenziate. Per proseguire, selezionare quella più pertinente</v-card-text
          >
          <v-list>
            <template v-for="item in currentJourneyTypeChoices">
              <v-divider :key="`v-divider-${item.id}`" />
              <v-list-item :key="`v-list-item-${item.id}`" :disabled="item.disabled">
                <v-list-item-avatar>
                  <v-icon :class="item.iconColor" dark> {{ item.icon }} </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-html="item.title" />
                  <v-list-item-subtitle :class="{ 'text--disabled': item.disabled }" v-html="item.desc" />
                  <v-list-item-subtitle v-html="item.example" class="text--disabled" />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn depressed @click.native="form.type = item.id" :disabled="item.disabled">Seleziona</v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </div>
    </v-form>

    <goods-map-form-modal ref="goodsFormModal" />

    <!-- MESSAGES -->
    <v-expand-transition>
      <v-alert :type="submitted ? `error` : `info`" text tile dense v-if="allowEmpty">
        <strong>Non puoi aggiungere un'altro viaggio senza carico.</strong><br />
        Ai fini della rilevazioni, due o più viaggi consecutivi senza carico, nella stessa giornata, non sono rilevanti.
        Si proceda descrivendo i successivi viaggi senza carico come se fosse un unico viaggio fino alla prima località
        in cui è stata caricata della merce.
      </v-alert>
    </v-expand-transition>
    <v-expand-transition>
      <v-alert :type="submitted ? `error` : `info`" text tile dense v-if="isRoundOrShuttle && !hasAtLeastOneGoods">
        Specificare almeno una delle merci, oppure sezionale l'opzione “Viaggio senza carico”.
      </v-alert>
    </v-expand-transition>
    <v-expand-transition>
      <v-alert :type="submitted ? `error` : `info`" tile dense v-if="isStandard && !hasAtLeastOneGoodsLoadedOrUnloaded">
        Un viaggio con carico è valido solo se in almeno uno delle località è stata scaricata o caricata della merce.<br />
        <small
          >Imposta almeno un valore maggiore di zero oppure una località dove è stata effettuata una operazione di
          carico e/o scarico.</small
        >
      </v-alert>
    </v-expand-transition>
  </div>
</template>

<script>
// Components
import GoodsMapFormModal from '@/components/modals/GoodsMapFormModal.vue'

import JourneyFormGoodsTable from '@/components/forms/JourneyFormGoodsTable.vue'
import JourneyFormStandardGoodsTable from '@/components/forms/JourneyFormStandardGoodsTable.vue'
import JourneyFormStandardGoodsTableRow from '@/components/forms/JourneyFormStandardGoodsTableRow.vue'

import SearchPlaceField from '@/components/forms/SearchPlaceField.vue'

// Types
import { placeTypes, coupledVehicleTypes, embarkingTypes, Helper as TypesHelper } from '@/types'
import { JourneyType, JourneyType2 } from '@/types/enum'

// Data
import borders from '@/data/borders.json'
import countries from '@/data/countries.json'

// Helpers
import { clone } from '@/helpers'

// Rules
import { required, number, min, max } from '@/validations'

// Models
import { createJourneyInstance } from '@/models'

// Constants
const SHUTTLE_MIN_JOURNEYS_COUNT = 3
const ROUND_MIN_JOURNEYS_COUNT = 1
const ROUND_MIN_STOPS_COUNT = 3

const STANDARD_MAX_WEIGTH = 440

// Component
export default {
  name: 'JourneyForm',
  components: {
    SearchPlaceField,
    GoodsMapFormModal,
    JourneyFormGoodsTable,
    JourneyFormStandardGoodsTable,
    JourneyFormStandardGoodsTableRow,
  },
  props: {
    type: {
      type: Number,
    },
    // prefillOriginPlace: {
    //   type: Object,
    //   default: null,
    // },
    // prefillDestinationPlace: {
    //   type: Object,
    //   default: null,
    // },
    dense: {
      type: Boolean,
      default: false,
    },
    previousJourney: {
      type: Object,
      default: null,
    },
    journey: {
      type: Object,
      default: null,
    },
    nextJourney: {
      type: Object,
      default: null,
    },
    dates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Form
      lazyValidation: false,
      valid: false,
      submitted: false,
      form: createJourneyInstance(),

      // data
      borders,
      countries,

      // Types
      placeTypes,
      // vehicleAxlesTypes,
      coupledVehicleTypes,
      embarkingTypes,

      // Rules
      // placeRules: [required],
      placeTypeRules: [required],
      distanceRules: [required, number, min(1)],
      exceptionalTransportDescRules: [required],
    }
  },
  created() {
    const form = Object.assign({}, this.form, clone(this.journey))

    const isNew = !this.journey.id

    if (
      isNew &&
      !!this.previousJourney &&
      this.previousJourney?.type2 === JourneyType2.STANDARD_MULTI &&
      !this.previousJourney?.is_ended
    ) {
      form.type = JourneyType.STANDARD
      form.parent_id = this.previousJourney?.parent_id || this.previousJourney.id

      form.goods = this.previousJourney.goods.map((item) => ({
        ...item,
        weights: {
          loaded: null,
          unloaded: null,
          onboard: item.weights.remaining,
          remaining: 0,
        },
        is_inherited: true,
      }))
    }

    this.form = form
  },
  watch: {
    'form.type': {
      immediate: true,
      deep: true,
      handler(newType, oldType) {
        const { STANDARD, ROUND, SHUTTLE } = JourneyType

        if (newType === STANDARD) {
          // TODO: meglio se si resettano i pesi
          this.form.goods = this.form.goods.filter((o) => !!o)
          return
        }

        if (newType === ROUND || newType === SHUTTLE) {
          if (oldType === STANDARD) this.form.goods = [null, null]

          if (newType === ROUND) {
            this.form.journeys_count = ROUND_MIN_JOURNEYS_COUNT
            this.form.stops_count = this.form.stops_count || ROUND_MIN_STOPS_COUNT
            this.form.stops_province_count = this.form.stops_province_count || null
            return
          } else {
            this.form.journeys_count = this.form.journeys_count || SHUTTLE_MIN_JOURNEYS_COUNT
          }
        }
      },
    },
    'form.goods': {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.isRoundOrShuttle && value?.[0] && value?.[1]) {
          this.form.distance_empty = 0
        }
      },
    },
  },
  computed: {
    dateItems() {
      return this.dates.map((d, index) => {
        const disabled = index < this.previousJourney?.day || index > this.nextJourney?.day
        return {
          id: index,
          desc: d,
          disabled,
        }
      })
    },
    hasPreviusNotFinished() {
      if (!this.previousJourney) return false

      return !this.previousJourney.is_ended && this.previousJourney.type === JourneyType.STANDARD
    },
    allowEmpty() {
      if (!this.form.type) return
      if (!this.isEmpty) return false
      if (!this.hasPreviousJourney) return false
      if (this.previousJourney.type !== JourneyType.EMPTY) return false
      if (this.form.day !== this.previousJourney.day) return false

      return true
    },
    hasSameOriginAndDestination() {
      return this.form.origin && this.form.destination && this.form.origin.id === this.form.destination.id
    },
    hasOrigin() {
      return !!this.form.origin
    },
    hasDestination() {
      return !!this.form.destination
    },
    hasSameProvince() {
      return (
        this.hasOrigin && this.hasDestination && this.form.origin?.province?.id === this.form.destination?.province?.id
      )
    },
    hasNeighboringProvinces() {
      return (
        this.form.origin?.province?.neighbors?.includes(this.form.destination?.province?.id) ||
        this.form.destination?.province?.neighbors?.includes(this.form.origin?.province?.id)
      )
    },
    // Types
    isEmpty() {
      return this.form.type === JourneyType.EMPTY
    },
    isStandard() {
      return this.form.type === JourneyType.STANDARD
    },
    isRound() {
      return this.form.type === JourneyType.ROUND
    },
    isShuttle() {
      return this.form.type === JourneyType.SHUTTLE
    },
    isRoundOrShuttle() {
      return this.isRound || this.isShuttle
    },
    isStandardNotEmpty() {
      return this.isStandard
    },
    isNew() {
      return !!this.journey?.id
    },
    isForeign() {
      return (
        (this.form.origin && this.form.origin?.country?.id !== 'IT') ||
        (this.form.destination && this.form.destination?.country?.id !== 'IT')
      )
    },
    hasAtLeastOneGoods() {
      return Object.values(this.form.goods).some((v) => !!v)
    },
    activeGoods() {
      return this.isStandardNotEmpty ? this.form.goods?.filter((i) => !(i.is_inherited && i.onboard === 0)) : []
    },
    hasAtLeastOneGoodsLoadedOrUnloaded() {
      return this.form.goods?.reduce((acc, cur) => (acc += cur.weights.loaded + cur.weights.unloaded), 0) > 0
    },
    hasGoodsToMerge() {
      const checkDuplicateExists = (arr) => new Set(arr).size !== arr.length
      const mappedGoods = this.activeGoods.map((o) => `${o.type}_${o.aspect}`)

      return checkDuplicateExists(mappedGoods)
    },
    hasExceptionalTrasportGoods() {
      return this.activeGoods.some((g) => g.weights.loaded > STANDARD_MAX_WEIGTH)
    },
    typeRules() {
      return [required]
    },
    placeRules() {
      if (this.isRoundOrShuttle)
        return [
          required,
          () => this.hasSameProvince || this.hasNeighboringProvinces || 'Stessa provincia o province limitrofe',
        ]

      return [required]
    },
    loaded: {
      set(value) {
        this.form.is_empty = !value
      },
      get() {
        return !this.form.is_empty
      },
    },
    hasPreviousJourney() {
      return !!this.previousJourney
    },
    hasNextJourney() {
      return !!this.nextJourney
    },
    previousJourneyProp() {
      return this.previousJourney
    },
    hasPrevious() {
      return !!this.journey.previous_id
    },
    // Permissions
    canChangeOriginPlace() {
      return !this.hasPrevious
    },
    canChangeDestinationPlace() {
      return !this.hasNextJourney
    },
    canChangeJourneyType() {
      // if (this.isEmbarked || this.isForeign) return false
      if (this.hasPreviusNotFinished) return false

      return true
    },
    canChangeGoods() {
      if (this.isRoundOrShuttle || this.isEmpty) return true
      if (this.isStandard && !this.hasNextJourney) return true

      return false
    },
    canAddAnotherGoods() {
      return this.form.goods?.length < 3 && !this.hasNextJourney
    },
    canChangeEmbarking() {
      return !this.isRoundOrShuttle
    },
    allowedForeignPlace() {
      return this.isStandard || this.isEmpty
    },
    totalDistance() {
      if (!this.form.type) return
      if (this.isStandard || this.isEmpty) return this.form.distance_total
      return this.form.journeys_count * (this.form.distance_loaded + this.form.distance_empty)
    },
    // Rules
    distanceLoadedRules() {
      if (this.isShuttle) {
        return [required, min(1)]
      }
      return [required, min(1), max(350)]
    },
    distanceEmptyRules() {
      if (this.isShuttle) {
        if (this.form.goods[0] && this.form.goods[1]) return [required, min(0)]
        else return [required, min(1)]
      }
      if (this.isRound) {
        if (this.form.goods[0] && this.form.goods[1]) return [required, min(0), max(0)]
        if (this.hasSameOriginAndDestination) {
          return [required, min(0)]
        } else {
          return [required, min(1)]
        }
      }
      return []
    },
    embarkingPlaceRules() {
      return this.form.embarking_type ? [required] : []
    },
    crossedBorderRules() {
      return this.isForeign ? [required] : []
    },
    crossedCountriesRules() {
      return this.isForeign ? [(v) => v?.length <= 5 || 'Selezionare massimo 5 stati'] : []
    },
    journeysCountRules() {
      if (this.isShuttle) return [required, min(SHUTTLE_MIN_JOURNEYS_COUNT)]
      if (this.isRound) return [required, min(ROUND_MIN_JOURNEYS_COUNT)]
      return null
    },
    stopsCountRules() {
      return this.isRound ? [required, min(ROUND_MIN_STOPS_COUNT)] : null
    },
    stopsProvinceCountRules() {
      return this.isRound ? [required, max(this.form.stops_count) || `Max ${this.form.stops_count}`] : null
    },
    requireSplittedDistance() {
      return this.form.type === JourneyType.ROUND || this.type === JourneyType.SHUTTLE
    },
    vehicleAxlesRules() {
      return this.form.coupled_vehicle ? [required] : []
    },
    vehicleLoadCapacityRules() {
      return this.form.coupled_vehicle ? [number, min(1)] : []
    },
    embarkingTypeRules() {
      return this.isEmbarked ? [required] : []
    },
    embarkingFromRules() {
      return this.isEmbarked ? [required] : []
    },
    embarkingToRules() {
      return this.isEmbarked ? [required] : []
    },
    //
    isEmbarked() {
      return this.form.embarking
    },
    journeyCountMinValue() {
      return this.isShuttle ? 4 : 1
    },
    allowEmbarking() {
      return this.form.type === JourneyType.STANDARD
    },
    showNumJourneys() {
      return this.form.type === JourneyType.ROUND || this.type === JourneyType.SHUTTLE
    },
    showNumStops() {
      return this.form.type === JourneyType.ROUND
    },
    hasEmbarking() {
      return !!this.form.embarking_type
    },
    journeyTypeChoices() {
      return [
        {
          id: 4,
          title: 'Viaggio senza carico',
          icon: 'mdi-map-marker-outline',
          iconColor: 'primary',
          desc: `L'automezzo ha viaggiato dalla località <strong><u>A</u></strong> alla <strong><u>B</u></strong> senza <strong>nessuna</strong> merce a bordo.`,
        },
        {
          id: 1,
          title: 'Viaggio standard',
          icon: 'mdi-map-marker-distance',
          iconColor: 'primary',
          desc: `L'automezzo è partito dalla località <strong><u>A</u></strong> con <strong>almeno</strong> una merce a bordo, per poi fermarsi nella località <strong><u>B</u></strong> dove ha <strong>scaricato parzialmente o completamente</strong> il carico.`,
          tip: ``,
          example: ``,
        },
        {
          id: 2,
          title: 'Circuito di raccolta e/o distribuzione',
          icon: 'mdi-map-marker-path',
          iconColor: 'purple',
          desc: `L'automezzo ha viaggiato dalla località <strong><u>A</u></strong> alla <strong><u>B</u></strong> (site nella stessa provincia o in province limitrofe)
          facendo <strong>almeno 4 fermate</strong>* dove ha scaricato e/o caricato <strong>sempre un solo tipo</strong> di merce`,
          tip: `* Nel caso di un numero di fermate inferiori a 4, descrivere i singoli viaggi usando le opzioni “Viaggio senza carico” e “Viaggio con carico`,
          example: `Ad esempio: raccolta urbana dei rifiuti, distribuzione del latte e raccolta delle bottiglie, distribuzione del pane, ecc`,
        },
        {
          id: 3,
          title: 'Navetta andata e ritorno',
          icon: 'mdi-swap-horizontal-bold',
          iconColor: 'green',
          desc: `L'automezzo ha fatto <strong>almeno 4 viaggi</strong>* di <strong>andata e ritorno</strong> dalla localita <strong><u>A</u></strong> alla <strong><u>B</u></strong>,
          trasportando <u>sempre la stessa merce all'andata</u> (o vuoto) e <u>sempre la stessa merce al ritorno</u> (o vuoto).`,
          example: `Ad esempio: fornitura cemento al cantiere: andata trasporta cemento al ritorno è senza carico`,
          tip: `* Nel caso di un numero di andate/ritorno inferiori a 4, descrivere i singoli viaggi usando le opzioni “Viaggio senza carico” e “Viaggio con carico”`,
        },
      ]
    },
    currentJourneyTypeChoices() {
      return this.journeyTypeChoices.map((o) => {
        let disabled = false

        if (o.id === JourneyType.ROUND || o.id === JourneyType.SHUTTLE) {
          if (
            this.isEmbarked ||
            this.isForeign ||
            this.hasPreviusNotFinished ||
            !(this.hasSameProvince || this.hasNeighboringProvinces)
          )
            disabled = true

          // if (this.isForeign || this.hasEmbarking)
          //   // || (!!this.previousJourney && !this.previousJourney?.is_ended)
          //   disabled = true
        }

        return {
          ...o,
          disabled,
        }
      })
    },
    originText() {
      const type = TypesHelper(placeTypes).getDescById(this.form.origin_type) || ''
      const place = this.form.origin?.full_name ?? ''
      return `<span class="font-weight-medium">${place}</span> <span class="text--secondary ml-2">${type}</span>`
    },
    destinationText() {
      const type = TypesHelper(placeTypes).getDescById(this.form.destination_type) || ''
      const place = this.form.destination?.full_name ?? ''

      return `<span class="font-weight-medium">${place}</span> <span class="text--secondary ml-2">${type}</span>`
    },
    embarkingText() {
      if (this.form.embarking_type === 0) return 'Nessuno'

      const type = TypesHelper(embarkingTypes).getDescById(this.form.embarking_type)
      const from = this.form.embarking_from?.full_name ?? ''
      const to = this.form.embarking_to?.full_name ?? ''

      return `Su ${type} da ${from} a ${to}`
    },
    formIsValid() {
      const formsAreValid = [this.valid].every((v) => v !== false)

      const businessLogicRules = []

      if (this.isRoundOrShuttle) {
        businessLogicRules.push(this.hasAtLeastOneGoods)
      }

      if (this.isStandardNotEmpty) {
        businessLogicRules.push(this.hasAtLeastOneGoodsLoadedOrUnloaded)
      }

      businessLogicRules.push(!this.allowEmpty)

      const businessLogicRulesAreValid = businessLogicRules.every((v) => !!v)

      return {
        isValid: formsAreValid && businessLogicRulesAreValid,
      }
    },
  },
  methods: {
    async validateAllForms() {
      try {
        await this.$refs['journeyForm']?.validate()
      } catch (error) {
        console.error(error)
      }
    },
    cleanData() {
      if (!this.form.embarking) {
        this.form.embarking_type = null
        this.form.embarking_from = null
        this.form.embarking_to = null
      }

      if (!this.form.coupled_vehicle) {
        this.form.coupled_vehicle_axles = null
        this.form.coupled_vehicle_load_capacity = null
      }

      if (!this.isForeign) {
        this.form.crossed_border = null
        this.form.crossed_countries = []
      }

      if (this.form.type === JourneyType.EMPTY) {
        this.form.type2 = JourneyType2.STANDARD_EMPTY
        this.form.is_ended = true

        // TODO: inizializzare goods
        return
      }

      if (this.form.type === JourneyType.STANDARD) {
        const hasRemaining = Object.values(this.form.goods).some((g) => g && g.weights.remaining !== 0)

        if (hasRemaining) {
          this.form.type2 = JourneyType2.STANDARD_MULTI
          this.form.is_ended = false
          return
        }

        this.form.is_ended = true
        this.form.type2 = this.form.parent_id ? JourneyType2.STANDARD_MULTI : JourneyType2.STANDARD_MONO

        return
      }

      if (this.form.type === JourneyType.ROUND || this.form.type === JourneyType.SHUTTLE) {
        this.form.distance_total = (this.form.distance_loaded + this.form.distance_empty) * this.form.journeys_count

        this.form.embarking = false
        this.form.embarking_type = null
        this.form.embarking_from = null
        this.form.embarking_to = null

        this.form.crossed_border = null
        this.form.crossed_countries = []

        this.form.is_ended = true

        if (this.form.type === JourneyType.SHUTTLE) {
          this.form.stops_count = null
          this.form.stops_province_count = null

          if (this.form.goods[0] && this.form.goods[1]) this.form.type2 = JourneyType2.SHUTTLE_OUTWARD_AND_RETURN
          else if (!this.form.goods[0]) this.form.type2 = JourneyType2.SHUTTLE_ONLY_RETURN
          else this.form.type2 = JourneyType2.SHUTTLE_ONLY_OUTWARD

          return
        }

        if (this.form.type === JourneyType.ROUND) {
          if (this.form.goods[0] && this.form.goods[1]) this.form.type2 = JourneyType2.ROUND_COLLECTION_AND_DISTRIBUTION
          else if (this.form.goods[0] && !this.form.goods[1]) this.form.type2 = JourneyType2.ROUND_COLLECTION
          else this.form.type2 = JourneyType2.ROUND_DISTRIBUTION

          this.form._meta.require_return = !this.hasSameOriginAndDestination

          return
        }
      }
    },
    async validate() {
      this.cleanData()
      await this.$refs.journeyForm?.validate()
      return this.valid
    },
    async reset() {
      await this.$refs.journeyForm?.reset()
    },
    resetValidation() {
      this.$refs.journeyForm?.resetValidation()
    },
    async submit() {
      this.cleanData()
      this.submitted = true

      const valid = await this.validateAllForms()

      if (!this.formIsValid.isValid) return

      const formData = clone(this.form)
      this.formIsValid.isValid && this.$emit('submit', formData)

      return { data: valid ? this.form : null, valid }
    },
    openModalGoods(index) {
      const goods = this.form.goods?.[index]

      this.$refs.goodsFormModal?.open(goods, this.isStandard).then((obj) => {
        if (!obj) return
        this.$set(this.form.goods, index, obj)
      })
    },

    setGoods(index) {
      this.$refs.goodsFormModal?.open(null).then((obj) => {
        if (!obj) return
        this.$set(this.form.goods, index, obj)
      })
    },

    unsetGoods(index) {
      this.$root.$confirm('Elimina merce', 'Vuoi davvero eliminare questa merce?', { color: 'red' }).then((confirm) => {
        if (confirm) this.$set(this.form.goods, index, null)
      })
    },

    // Operazioni sulle merci
    deleteGoods(index) {
      if (this.form.goods?.[index]?.is_inherited) {
        alert('Non puoi eliminare questa merce perchè é a bordo dal viaggio precedente.')
        return
      }
      this.$root.$confirm('Elimina merce', 'Vuoi davvero eliminare questa merce?', { color: 'red' }).then((data) => {
        data && this.form.goods.splice(index, 1)
      })
    },
    editGoods(index) {
      const data = this.form.goods?.[index]
      const g = this.isStandard
        ? this.form.goods.filter((o, i) => i !== index && !(o.is_inherited && o.weights.onboard === 0))
        : null

      // TODO: meglio se multi e goods vengono passati come oggetto options
      this.$refs.goodsFormModal?.open(data, this.isStandard, g).then((data) => {
        data && this.$set(this.form.goods, index, data)
      })
    },
    addGoods() {
      const g = this.isStandard ? this.form.goods.filter((o) => !(o.is_inherited && o.weights.onboard === 0)) : null

      // TODO: meglio se multi e goods vengono passati come oggetto options
      this.$refs.goodsFormModal?.open(null, this.isStandard, g).then((data) => {
        data && this.form.goods.push(data)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.label {
  padding-bottom: 8px;
  font-size: 16px;
}
b,
strong {
  font-weight: medium !important;
}
::v-deep .v-application code {
  background-color: transparent !important;
  color: var(--primary);
  padding: 0 0.4rem;
}

::v-deep div[class^='col-'],
div[class^='col'] {
  padding-bottom: 2px !important;
  padding-top: 0px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.input-row {
  margin-bottom: -24px;
}

.input-text {
  ::v-deep {
    .v-text-field {
      input {
        color: blue;
      }
    }
  }
}
</style>
